module.exports = __webpack_public_path__ + "static/media/roll-dice-before.5034a9ac.png";